function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1925 1750",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.417,273.049L167.928,357.004L136.439,252.054L377.828,73.653L199.417,273.059L199.417,273.049ZM452.729,5.987C444.856,-0.694 432.49,-1.645 419.708,3.486L419.689,3.486C406.243,8.876 39.13,166.346 24.189,172.779C21.467,173.72 -2.269,182.58 0.176,202.311C2.363,220.104 21.439,227.469 23.774,228.318L117.105,260.277C123.288,280.885 146.12,356.93 151.16,373.182C154.315,383.306 159.447,396.614 168.445,399.355C176.335,402.401 184.18,399.614 189.265,395.626L246.327,342.7L338.43,414.537L340.636,415.847C346.884,418.616 352.882,419.999 358.595,419.999C363.025,419.999 367.261,419.169 371.313,417.517C385.109,411.851 390.628,398.7 391.21,397.214L460.011,39.58C464.21,20.476 458.377,10.758 452.72,5.987L452.729,5.987Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.65ccbc68.svg";
export { ForwardRef as ReactComponent };